<!-- Period heading + grand total -->
<div class="period-row" [class.hidden]="entries.length === 0">
  <div class="period-left">
    <span class="period-label">{{ period }}</span>
    <button class="excel-btn" (click)="exportToExcel()" [disabled]="entries.length === 0">
      <img src="assets/images/billing/excel.svg" alt="" />
      {{ 'BILLING.EXCEL' | translate }}
    </button>
  </div>
  <div class="period-total">
    {{ 'BILLING.TOTAL' | translate }}: <span class="total-amount">{{ grandTotal }}</span>
  </div>
</div>

<!-- One card per site / empty state -->
<div class="site-cards">
  @for (entry of entries; track entry.site) {
    <app-invoice-item [site]="entry.site" [displayEvents]="entry.events"></app-invoice-item>
  } @empty {
    <div class="invoice-empty-state">
      <img src="assets/images/reports/empty_state.svg" alt="" />
      <span class="empty-title">{{ 'BILLING.NO_INVOICES' | translate }}</span>
      <span class="empty-sub">{{ 'BILLING.NO_INVOICES_SUB' | translate }}</span>
    </div>
  }
</div>
